import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { CRMReportRequest } from '../crm-data-by-zip-territory.component';
import { DataGridCreatedEvent } from '../crm-report-datagrid/crm-report-datagrid-defns';
import { exportDataGrid, exportPivotGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { DxDataGridComponent, DxLoadPanelComponent, DxPivotGridComponent } from 'devextreme-angular';
import { CrmDataByZipTerritoryService } from '../crm-data-by-zip-territory.service';
import { NotificationService } from 'src/app/common/component/notification/notification.service';


@Component({
  selector: 'app-crm-report-leads-open-lost-won',
  templateUrl: './crm-report-leads-open-lost-won.component.html',
  styleUrls: ['./crm-report-leads-open-lost-won.component.scss']
})
export class CrmReportLeadsOpenLostWonComponent implements OnInit, AfterViewInit {

  @Input()
  reportRequest: CRMReportRequest;
  
  @ViewChild('OpenLeadsTerrFYQtr', { static: false }) openLeadsTerrFYQtrGrid: DxPivotGridComponent;
  @ViewChild('OpenLeadsByCampaign', { static: false }) openLeadsByCampaignGrid: DxPivotGridComponent;
  @ViewChild('openLeads_loadpanel', { static: false }) openLeads_LoadPanel: DxLoadPanelComponent;

  childDataGrids: Array<DataGridCreatedEvent> = new Array<DataGridCreatedEvent>();

  openLeads_heading1: string = '';
  lostLeads_heading1: string = '';
  wonLeads_heading1: string = '';
  allLeadsDetails_heading1: string = '';

  maxRetries = 1;
  retryCount = 0;

  pivotGrid_OpenLeadsTerrFYQtr_Datasource: any; 
  pivotGrid_OpenLeadsByCampaign_Datasource: any;
  pivotGrid_LostLeadsBySinceDate_Datasource: any;
  pivotGrid_WonLeadsBySinceDate_Datasource: any;

  workbook: any;
  excelColMaxWidth = 30;
  excelColMinWidth = 13;

  openLeads_totalCells_RowIdxArray: Array<number> = new Array<number>();

  constructor(private notificationService: NotificationService, private crmDataByZipTerritoryService: CrmDataByZipTerritoryService) { }

  ngOnInit(): void {
    this.setReportHeadings();
    this.getOpenLeadsDetails();
  }

  ngAfterViewInit(): void {
    this.openLeads_LoadPanel.visible = true;
  }

  setReportHeadings(){    
    this.setReportHeadings_OpenLeads();
    this.setReportHeadings_AllLeadsDetails();       
  }

  setReportHeadings_OpenLeads(){
    if(this.reportRequest.territoryValue){
      this.openLeads_heading1 = "CRM 'Open' Leads in the Geography of " + this.reportRequest.territoryValue;
    }else if(this.reportRequest.postCodeValue){
      this.openLeads_heading1 = 'Leads within ' + String(this.reportRequest.radiusMiles) + ' miles of ' + this.reportRequest.postCodeValue;
    }
  }

  setReportHeadings_AllLeadsDetails(){
    if(this.reportRequest.territoryValue){
      this.allLeadsDetails_heading1 = 'CRM All Leads in the Geography of ' + this.reportRequest.territoryValue;
    }else if(this.reportRequest.postCodeValue){
      this.allLeadsDetails_heading1 = 'Leads within ' + String(this.reportRequest.radiusMiles) + ' miles of ' + this.reportRequest.postCodeValue;
    }
  }

  getOpenLeadsDetails(){

    this.crmDataByZipTerritoryService.getCRMReport(this.reportRequest, 'LeadsOLW_OpenLeadsDetails').subscribe({
      next: crmReportData_openLeadsDetails => {    
        this.setOpenLeadsTerrFYQtr_Datasource(crmReportData_openLeadsDetails);
        this.setOpenLeadsByCampaign_Datasource(crmReportData_openLeadsDetails);
        this.openLeads_LoadPanel.visible = false;
                       
        let openLeadsTerrFYQtr_created_event: DataGridCreatedEvent = {
          reportType: "LeadsOLW_OpenLeadsTerrFYQtr", 
          dataGridComponent: this.openLeadsTerrFYQtrGrid
        };

        this.onDataGridCreated(openLeadsTerrFYQtr_created_event);   
        
        let openLeadsByCampaign_created_event: DataGridCreatedEvent = {
          reportType: "LeadsOLW_OpenLeadsByCampaign", 
          dataGridComponent: this.openLeadsByCampaignGrid
        };

        this.onDataGridCreated(openLeadsByCampaign_created_event);

      },
      error: (errorResponse: any) => {

        if(errorResponse.status == 504){ // if gateway timeout error.
          if(this.retryCount < this.maxRetries){ // attempt a retry if max retries not reached
            this.retryCount++;
            this.getOpenLeadsDetails();
            return;
          }
        }

        this.openLeads_LoadPanel.visible = false;
        this.notificationService.alert("error", "Error while fetching CRM Report data", errorResponse);
      }
    });

  }


  setOpenLeadsTerrFYQtr_Datasource(crmReportData_openLeadsDetails: any){
    this.pivotGrid_OpenLeadsTerrFYQtr_Datasource = {
      fields: [{
        caption: 'CRM Territory',
        width: 120,
        dataField: 'territoryCRM',
        expanded: true,        
        area: 'row',
      }, {
        caption: 'FY',
        width: 120,
        dataField: 'fy',        
        area: 'row',
      }, {
        caption: 'Quarters',
        width: 120,
        dataField: 'quarter',
        area: 'column',
      }, 
      {
        caption: 'Count of Leads',
        dataField: 'quarter',
        dataType: 'string',
        summaryType: 'count',
        area: 'data',
        format: { type: 'fixedPoint', precision: 0 }
      }],
      store: crmReportData_openLeadsDetails
    }
  }

  setOpenLeadsByCampaign_Datasource(crmReportData_openLeadsDetails: any){
    this.pivotGrid_OpenLeadsByCampaign_Datasource = {
      fields: [{
        caption: 'Campaign',
        width: 400,
        dataField: 'campaign',
        expanded: false,        
        area: 'row',
      }, {
        caption: 'Company',
        width: 200,
        dataField: 'company',        
        area: 'row',
      }, {
        caption: 'Qualification Level',
        width: 120,
        dataField: 'leadQualificationLevel',
        area: 'column',
      }, 
      {
        caption: 'Qualification Level',
        dataField: 'leadQualificationLevel',
        dataType: 'string',
        summaryType: 'count',
        area: 'data',
        format: { type: 'fixedPoint', precision: 0 }
      }],
      store: crmReportData_openLeadsDetails
    }
  }

  async exportExcel(e) {

    this.workbook = new Workbook();

    //Open Leads Tab
    await this.createOpenLeads_worksheet();

    //All Leads Details
    let allLeadsDetails_datagrid_idx = this.childDataGrids.findIndex(event => event.reportType == 'LeadsWith91MA_AllLeadsDetails');

    if(allLeadsDetails_datagrid_idx >= 0){
      await this.createAllLeadsDetails_worksheet(this.childDataGrids[allLeadsDetails_datagrid_idx].dataGridComponent);
    }
    
    await this.workbook.xlsx.writeBuffer()
    .then(function (buffer: BlobPart) {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'cdbLeadMaster.xlsx');
    });
    

  }

  async createOpenLeads_worksheet(){

    let worksheet = null;

    let openLeadsTerrFYQtr_datagrid_idx = this.childDataGrids.findIndex(event => event.reportType == 'LeadsOLW_OpenLeadsTerrFYQtr');
    let openLeadsByCampaign_datagrid_idx = this.childDataGrids.findIndex(event => event.reportType == 'LeadsOLW_OpenLeadsByCampaign');

    if(openLeadsTerrFYQtr_datagrid_idx >= 0 || openLeadsByCampaign_datagrid_idx >= 0){
      worksheet = this.workbook.addWorksheet('Open Leads');
    }else{
      return;
    }

    let excelRow_Last = 1;

    if(openLeadsTerrFYQtr_datagrid_idx >= 0){

      let dataSource = this.openLeadsTerrFYQtrGrid.instance.getDataSource();

      await dataSource.expandAll(dataSource.field("territoryCRM").index);      

      await exportPivotGrid({
        component: this.childDataGrids[openLeadsTerrFYQtr_datagrid_idx].dataGridComponent.instance,
        worksheet: worksheet,
        topLeftCell: { row: 3, column: 1 },
        customizeCell: this.customizeCell_openLeadsTerrFYQtr
      }).then((cellRange) => {
        //Pivotgrid export freezes the first few columns. We don't want that, so we unfreeze.
        worksheet.views = [{state: 'normal'}];
        excelRow_Last = cellRange.to.row;
        
      }).then(() => {

        //Some standard style definitions to re-use further below.
        let stdHeaderFill =  {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'1C3A70'},          
        };

        let stdBorder = {
          top: {style:'thin', color: {argb:'000000'}},
          left: {style:'thin', color: {argb:'000000'}},
          bottom: {style:'thin', color: {argb:'000000'}},
          right: {style:'thin', color: {argb:'000000'}}
        }

        let stdHeaderFont = { name: 'Arial', size: 10, color: { argb: 'ffffff' }, bold: true };

        //Unmerge these cells and add the column headers to A3 and B3 cells
        worksheet.unMergeCells('A3');

        let cellA3Properties = {
          value: 'CRM Territory',
          fill: stdHeaderFill,
          font: stdHeaderFont,
          alignment: { vertical: 'top', horizontal: 'left' }
        }

        Object.assign(worksheet.getCell('A3'),cellA3Properties);

        let cellB3Properties = {
          value: 'FY',
          fill: stdHeaderFill,
          border: stdBorder,
          font: stdHeaderFont
        };

        Object.assign(worksheet.getCell('B3'), cellB3Properties);

        //Merge two cells to add a sub level header
        worksheet.mergeCells('A2:B2');

        let cellA2Properties = {
          value: 'Count of Leads',
          fill: {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'ffffff'},          
          },
          font: { name: 'Arial', size: 10, color: { argb: '000000' }, bold: true },          
          border: stdBorder,
          alignment: { vertical: 'top', horizontal: 'left' }          
        }

        Object.assign(worksheet.getCell('A2'), cellA2Properties);
        
        worksheet.getRow(2).height = 21;

        //Merge the top row cells and add the grid level header
        worksheet.mergeCells('A1:G1');      
        worksheet.getCell('A1').value = {
          'richText': [
            {'font': {'size': 18,'color': {'argb': '1C3A70'},'name': 'Tahoma'},'text': this.openLeads_heading1},          
          ]
        };

        worksheet.getCell('A1').alignment = {
          vertical: 'top',
          horizontal: 'left',
          wrapText: true
        }
        
        worksheet.getRow(1).height = 24;
      });
    }
    
    if(openLeadsByCampaign_datagrid_idx >= 0){
      let dataSource = this.openLeadsByCampaignGrid.instance.getDataSource();
    
      await dataSource.expandAll(dataSource.field("campaign").index);

      let excelRow_Start = (excelRow_Last != 3) ? (excelRow_Last + 4) : excelRow_Last;
      let excelColumn_End: number = 0;

      await exportPivotGrid({
        component: this.childDataGrids[openLeadsByCampaign_datagrid_idx].dataGridComponent.instance,
        worksheet: worksheet,
        topLeftCell: { row: excelRow_Start, column: 1 },
        customizeCell: this.customizeCell_openLeadsByCampaign
      }).then((cellRange) => {
        
        dataSource.collapseAll(dataSource.field("campaign").index);

        //Pivotgrid export freezes the first few columns. We don't want that, so we unfreeze.
        worksheet.views = [{state: 'normal'}];

        worksheet.properties.outlineProperties = {
          summaryBelow: true,
          summaryRight: false,
        };

        worksheet.getColumn('A').width = 43;
        worksheet.getColumn('B').width = 35;
        
        excelColumn_End = cellRange.to.column;

      }).then(() =>{


        //Some standard style definitions to re-use further below.
        let stdHeaderFill =  {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'1C3A70'},          
        };

        let stdBorder = {
          top: {style:'thin', color: {argb:'000000'}},
          left: {style:'thin', color: {argb:'000000'}},
          bottom: {style:'thin', color: {argb:'000000'}},
          right: {style:'thin', color: {argb:'000000'}}
        }

        let stdHeaderFont = { name: 'Arial', size: 10, color: { argb: 'ffffff' }, bold: true };

        //Unmerge column header cells and add the column headers to them.
        let excelCell_1 = "".concat('A',String(excelRow_Start));

        worksheet.unMergeCells(excelCell_1);

        let cellProperties1 = {
          value: 'Campaign',
          fill: stdHeaderFill,
          font: stdHeaderFont,
          alignment: { vertical: 'top', horizontal: 'left' }
        }

        Object.assign(worksheet.getCell(excelCell_1), cellProperties1);

        let excelCell_2 = "".concat('B',String(excelRow_Start));

        let cellProperties2 = {
          value: 'Company',
          fill: stdHeaderFill,
          border: stdBorder,
          font: stdHeaderFont
        };

        Object.assign(worksheet.getCell(excelCell_2), cellProperties2);

        //To get the previous cell. For eg: if this grid starts at row 18, we take A17:B17, merge and add a main header
        let startCell1= "".concat('A',String(excelRow_Start-1));
        let endCell1 = "".concat('B',String(excelRow_Start-1));        

        //Merge two cells to add a main header
        worksheet.mergeCells(startCell1 + ':' + endCell1);

        let cellProperties3 = {
          value: 'Open Leads by Campaign',
          fill: {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'ffffff'},          
          },
          font: { name: 'Arial', size: 10, color: { argb: '000000' }, bold: true },
          border: stdBorder,
          alignment: { vertical: 'top', horizontal: 'left' }          
        }

        Object.assign(worksheet.getCell(startCell1), cellProperties3);

        //Add 'Qualification Level' as a banding header (if grid has data).
        if(excelColumn_End > 2){
          let startRow = excelRow_Start-1;
          let endRow = excelRow_Start-1;
          let startColumn = 3;
          let endColumn = excelColumn_End;
          worksheet.mergeCells(startRow, startColumn, endRow, endColumn);

          let cellProperties4 = {
            value: 'Qualification Level',
            fill: stdHeaderFill,
            font: stdHeaderFont,
            border: stdBorder,
            alignment: { vertical: 'middle', horizontal: 'center' }          
          }
  
          Object.assign(worksheet.getRow(excelRow_Start-1).getCell(3), cellProperties4);
        }

        worksheet.getRow(excelRow_Start - 1).height = 18;

        //Create the drill-down view aka outlined view.
        // In the customizeCell function, we got the row-ids of 'row-level-total' rows into an array.
        // Now we will use this array to do a series of actions which will create the grouped rows view
        // aka drill-down view. In ExcelJS terminology this is called 'Outlining'.
        // Before we apply outlining, we need to unmerge/merge some cells, so that outlining can be applied.

        //First we adjust the row-ids relative to where the grid starts. Remember this sheet has two grids & this is the second.
        //Ex. If the grid starts at row 18, then adjust all items in the array by adding 18.
        let adjustedIdxArray = this.openLeads_totalCells_RowIdxArray.map(idx => idx + excelRow_Start);

        let prevIdx = excelRow_Start;

        //The campaign total row label cell is merged (Eg; A20,B20 are merged), so unmerge it. Restore border format after unmerge
        //Then unmerge the previous cell above. This is the campaign name cell.
        //Then merge the campain label cell and row toal cell. Ex A19 and A20 are merged.
        adjustedIdxArray.forEach((idx,i)=>{
          
          worksheet.unMergeCells('A'+String(idx));
          worksheet.getCell('B'+String(idx)).border = stdBorder;
          worksheet.unMergeCells('A'+String(idx - 1));
          worksheet.mergeCells('A' + String(prevIdx + 1) + ':' + 'A' + String(idx));
          prevIdx = idx;
        });

        //For each row in this grid, if it is a non-total row, set outline level to 1 and hide it (so that it is grouped and not visible).
        //If it is a total row, set outline level to 0 and let it stay visible.
        worksheet.eachRow((row,i) => {
          if(i > excelRow_Start && i <= adjustedIdxArray.slice(-1)){
            if(adjustedIdxArray.indexOf(i) == -1){
              row.outlineLevel = 1;
              row.hidden = true;
            }else{
              row.outlineLevel = 0;
            }
          }
        });
        
      });
    }

  }

  customizeCell_openLeadsTerrFYQtr = ({pivotCell, excelCell}) => {
          
    //We use this function to apply as much formatting as possible.
    // Because the 'pivotCell' object has some properties which indicate
    // what type of cell it is (data cell or row header or column header or grand total etc).
    // Otherwise it is difficult to identify using normal exceljs row/column/cell functions.


    //Apply formatting for each data cell (including grand total cells)
    let dataCellFmt = {
      numFmt: '#,##0',
      alignment: { vertical: 'middle', horizontal: 'center' }
    };

    if(this.isDataCell(pivotCell) || this.isGrandTotalDataCell(pivotCell)){
      excelCell.value = pivotCell.value? pivotCell.value as Number : pivotCell.value;
      Object.assign(excelCell, dataCellFmt);
    }

    //Apply some more formatting for each grand total cell
    let gtcellFormat = {
      fill: {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'FFEBCD'},
      },
      font: { name: 'Arial', size: 10, color: { argb: '000000' }, bold: true }
    };

    if(this.isAnyGrandTotalCell(pivotCell)){
      Object.assign(excelCell, gtcellFormat);
      if(pivotCell.area == 'row'){
        Object.assign(excelCell,{alignment: { vertical: 'middle', horizontal: 'right' }});
      }
    }

    //Apply bg-colors for row headers (CRM Territory and FY)
    let rowCellFormat1 = {
      fill: {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'B0C4DE'},
      }
    };

    let rowCellFormat2 = {
      fill: {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'D3D3D3'},
      }
    };

    if(pivotCell.area == 'row' && pivotCell.type == 'D'){
      if(pivotCell.columnIndex == 0){
        Object.assign(excelCell, rowCellFormat1);
      }else if(pivotCell.columnIndex == 1){
        Object.assign(excelCell, rowCellFormat2);
      }            
    };
    
    //Apply some formatting for column header cells (Q1, Q2 etc..)
    let colHeaderFormat1 =  {
      fill: {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'1C3A70'},
      },
      font: { name: 'Arial', size: 10, color: { argb: 'ffffff' }, bold: true }
    };

    if(pivotCell.area == 'column' && pivotCell.type == 'D'){
      Object.assign(excelCell, colHeaderFormat1);
    }
    
    //Apply border format for all cells in the pivot grid
    let cellBorder = {
      border: {
        top: {style:'thin', color: {argb:'000000'}},
        left: {style:'thin', color: {argb:'000000'}},
        bottom: {style:'thin', color: {argb:'000000'}},
        right: {style:'thin', color: {argb:'000000'}}
      }
    };

    Object.assign(excelCell, cellBorder);
  }

  customizeCell_openLeadsByCampaign = ({pivotCell, excelCell}) => {
    //Apply formatting for each data cell (including grand total cells)
    let dataCellFmt = {
      numFmt: '#,##0',
      alignment: { vertical: 'middle', horizontal: 'center' }
    };

    if(this.isDataCell(pivotCell) || this.isGrandTotalDataCell(pivotCell) || this.isRowOrColTotalDataCell(pivotCell)){
      excelCell.value = pivotCell.value? pivotCell.value as Number : pivotCell.value;
      Object.assign(excelCell, dataCellFmt);
    }

    //Apply some more formatting for each grand total cell
    let gtcellFormat = {
      fill: {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'FFEBCD'},
      },
      font: { name: 'Arial', size: 10, color: { argb: '000000' }, bold: true }
    };

    if(this.isAnyGrandTotalCell(pivotCell)){
      Object.assign(excelCell, gtcellFormat);

      if(pivotCell.area == 'row'){
        Object.assign(excelCell,{alignment: { vertical: 'middle', horizontal: 'right' }});
      }
    }

    //Apply some formatting for column header cells (Development, Initial etc..)
    let colHeaderFormat1 =  {
      fill: {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'B0C4DE'},
      },
      font: { name: 'Arial', size: 10, color: { argb: '000000' }, bold: true }
    };

    if(pivotCell.area == 'column' && pivotCell.type == 'D'){
      Object.assign(excelCell, colHeaderFormat1);
    }
    
    //Apply border format for all cells in the pivot grid
    let cellBorder = {
      border: {
        top: {style:'thin', color: {argb:'000000'}},
        left: {style:'thin', color: {argb:'000000'}},
        bottom: {style:'thin', color: {argb:'000000'}},
        right: {style:'thin', color: {argb:'000000'}}
      }
    };

    Object.assign(excelCell, cellBorder);

    //If it is a row-total cell, then store the rowIndex in an array. It will be used subsequently for grouping rows.
    if(pivotCell.area == 'row' && pivotCell.type == 'T' && pivotCell.text != ""){
      this.openLeads_totalCells_RowIdxArray.push(pivotCell.rowIndex);
    }
  }

  isDataCell(cell) {
    return (cell.area === 'data' && cell.rowType === 'D' && cell.columnType === 'D');
  }

  isGrandTotalDataCell(cell) {
    return (cell.area === 'data' && (cell.type === 'GT' || cell.rowType === 'GT' || cell.columnType === 'GT'));
  }

  isRowOrColTotalDataCell(cell){
    return (cell.area === 'data' && (cell.rowType === 'T' && cell.columnType != 'GT') || (cell.columnType === 'T') && cell.rowType != 'GT');
  }

  isAnyGrandTotalCell(cell){
    return (cell.type === 'GT' || cell.rowType === 'GT' || cell.columnType === 'GT');
  }


  //Export All Leads Details tab
  async createAllLeadsDetails_worksheet(dataGrid: DxDataGridComponent, columnFormatDetails?: Array<any>){

    const worksheet = this.workbook.addWorksheet('All Leads');

    await exportDataGrid({
      component: dataGrid.instance,
      worksheet: worksheet,
      topLeftCell: { row: 2, column: 1 },
    }).then((cellRange) => {

      //Set default alignment and font properties at the worksheet level
      worksheet.eachRow((row, i) => {
        row.alignment = {
          vertical: 'top',          
          wrapText: true
        }

        row.font = {
          name: 'Tahoma',
          size: 10
        }

        row.border = {
          top: {style:'thin', color: {argb:'000000'}},
          left: {style:'thin', color: {argb:'000000'}},
          bottom: {style:'thin', color: {argb:'000000'}},
          right: {style:'thin', color: {argb:'000000'}}
        };
      });        
      
      
    
    }).then(() => {
      
      let parser = new DOMParser();

      const leadIDColumn = worksheet.getColumn(1);

      leadIDColumn.eachCell((cell, rowNum) => {
        if(rowNum > 2){
          let parsedHtml = parser.parseFromString(cell.value, 'text/html');
          let anchorElement = parsedHtml.getElementsByTagName("a")[0];
          
          cell.value = {
            text: anchorElement.textContent,
            hyperlink: anchorElement.getAttribute('href'),
            tooltip: anchorElement.getAttribute('href')
          };
          
          cell.font = { name: 'Tahoma', size: 10, color: { argb: '0000ff' }, underline: true };
        }
      });

      const acctnumColumn = worksheet.getColumn(3);

      acctnumColumn.eachCell((cell, rowNum) => {
        if(rowNum > 2){
          let parsedHtml = parser.parseFromString(cell.value, 'text/html');
          let anchorElement = parsedHtml.getElementsByTagName("a")[0];
          
          cell.value = {
            text: anchorElement.textContent,
            hyperlink: anchorElement.getAttribute('href'),
            tooltip: anchorElement.getAttribute('href')
          };    
          
          cell.font = { name: 'Tahoma', size: 10, color: { argb: '0000ff' }, underline: true };
        }
      });

    }).then(() => {

      //Prepare Sheet header-1
      worksheet.mergeCells('A1:S1');      
      worksheet.getCell('A1').value = {
        'richText': [
          {'font': {'size': 18,'color': {'argb': '1C3A70'},'name': 'Tahoma'},'text': this.allLeadsDetails_heading1},          
        ]
      };

      worksheet.getCell('A1').alignment = {
        vertical: 'top',
        horizontal: 'left',
        wrapText: true
      }
      
      worksheet.getRow(1).height = 24; 

      //Set format for table header row
      const tableHeaderRow = worksheet.getRow(2);
      
      tableHeaderRow.fill = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'1C3A70'},
      };                  

      tableHeaderRow.font = { name: 'Tahoma', size: 11, color: { argb: 'ffffff' }, bold: true };
      tableHeaderRow.height = 27;
      
      //fill style
      const header_fill_1 = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'6A5ACD'},
      };            

      //Change fill color and border for certain header cells
      [21,22,23,24,25].forEach((i) => {
        tableHeaderRow.getCell(i).fill = header_fill_1;
      });      

      const header_fill_2 = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'006400'},
      };

      //Change fill color for certain header cells
      [38,39,40,41].forEach((i) => {        
        tableHeaderRow.getCell(i).fill = header_fill_2;
      });

      const header_fill_3 = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'0000FF'},
      };

      //Change fill color for certain header cells
      [42,43,44,45,46,47].forEach((i) => {        
        tableHeaderRow.getCell(i).fill = header_fill_3;
      });

      //Adjust column widths for better appearance      
      worksheet.columns.forEach((column,i) => {

        if(column.width > this.excelColMaxWidth){
          column.width = this.excelColMaxWidth;
        }

        //adjust column width based on the header text length
        if(i > 37 && (!column.width || column.width < this.excelColMinWidth)){
          if(tableHeaderRow.getCell(i).value.length > 16){            
            column.width = 18;
          }else{
            column.width = this.excelColMinWidth;
          }
          
        }
      });

    });

  }
  //Receive datagrid created events and store the event meta-data.
  //This will be used for the export-to-excel functionality
  onDataGridCreated(event: DataGridCreatedEvent){       
    this.childDataGrids.push(event);
  }

}
